<template>
  <el-row>
    <el-col>
      <WatchlistDialog
        v-if="isShowWatchlistDialog"
        ref="watchlistDialog"
        :watchlist="watchlist"
        :consignment-id="$route.params.consignmentId"
        :is-show.sync="isShowWatchlistDialog"
        @saved="load"
      />
      <div
        v-if="isLoading"
        v-loading="isLoading"
        class="mt-5"
      />
      <el-card
        v-else
        v-loading="isLoading"
        shadow="never"
      >
        <el-table
          :data="consignment.watchlists"
          stripe
        >
          <el-table-column
            label="Profile"
            prop="profile"
            :formatter="(row, col, cellValue) => cellValue ? cellValue.email : '-'"
          />
          <el-table-column
            label="Notes"
            prop="notes"
          />
          <el-table-column
            label="Watch Until"
            prop="watch_until"
            :formatter="(row, col, cellValue) => {
              const option = watchUntilOptions.find(option => option.id === cellValue)
              return option ? option.label : '-'
            }"
          />
          <el-table-column
            label="Send Notifications"
            prop="send_notifications"
            :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
          />
          <el-table-column
            label="Created At"
            prop="created_at"
          />
          <el-table-column
            label="Actions"
            width="180"
          >
            <template #default="{ row }">
              <el-button
                size="mini"
                @click.native="openEditDialog(row)"
              >
                Edit
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click.native="deleteWatchlist(row)"
              >
                Delete
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import WatchlistDialog from '@/components/Application/Freight/Consignments/WatchlistDialog'

export default {
  components: {
    WatchlistDialog
  },
  data () {
    return {
      title: 'Watchlist',
      breadcrumb: {
        name: 'Watchlist',
        route: { name: 'freight-consignments-v3-consignment-watchlist', params: { consignmentId: this.$route.params.consignmentId } }
      },
      actions: [
        {
          name: 'Add',
          icon: ['fal', 'plus'],
          event: () => { this.openCreateDialog() }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => { this.load() }
        }
      ],
      watchlist: null,
      isShowWatchlistDialog: false,
      consignment: null,
      isLoading: false,
      watchUntilOptions: [
        { id: 'is_delivered', label: 'Watch until delivered' },
        { id: 'is_delivered_plus_7', label: 'Watch until 7 days after delivery' },
        { id: 'is_delivered_plus_14', label: 'Watch until 14 days after delivery' },
        { id: 'is_cancelled', label: 'Watch until cancelled' },
        { id: '7_days', label: 'Watch for 7 days' },
        { id: '14_days', label: 'Watch for 14 days' },
        { id: '30_days', label: 'Watch for 30 days' },
        { id: '60_days', label: 'Watch for 60 days' },
        { id: '90_days', label: 'Watch for 90 days' },
        { id: 'indefinitely', label: 'Watch indefinitely' }
      ]
    }
  },
  created () {
    this.load()
  },
  methods: {
    openCreateDialog () {
      this.watchlist = new this.$sdk.watchlist()
      this.watchlist.send_notifications = true
      this.isShowWatchlistDialog = true
    },
    openEditDialog (watchlist) {
      this.watchlist = watchlist.clone()
      this.isShowWatchlistDialog = true
    },
    deleteWatchlist (watchlist) {
      this.$confirm('Are you sure you want to delete this watchlist entry?', 'Confirm', { type: 'warning' })
        .then(() => {
          watchlist.delete().then(() => {
            this.$message.success('Watchlist entry deleted')
            this.load()
          })
        })
    },
    load () {
      this.isLoading = true
      this
        .$sdk
        .consignment
        .read(this.$route.params.consignmentId, request => {
          request.include = [
            'watchlists.profile'
          ]
        })
        .then(res => { this.consignment = res })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>
